import { apiClient } from './client'

export interface AuthResponse {
  token: string
}

export const authApi = {
  /**
   * Authenticate user with Telegram initData
   * @param initDataRaw - Raw Telegram initData string
   */
  async authenticate(initDataRaw: string): Promise<AuthResponse> {
    return apiClient.post<AuthResponse>('/v1/auth/telegram', { initData: initDataRaw })
  },
}
